import { defineMessages } from 'react-intl'

const scope = `procurify.platform.iam.feature-sets.ReportAccessView`

export default defineMessages({
  clearAllConfirmHeader: {
    id: `${scope}.clearAllConfirmHeader`,
    defaultMessage: 'Confirmation',
  },
  clearAllConfirmMessage: {
    id: `${scope}.clearAllConfirmMessage`,
    defaultMessage:
      'Are you sure you want to remove all {count} user(s) report permissions from {secondaryCategoryName}?',
  },
  bulkRemoveConfirmHeader: {
    id: `${scope}.bulkRemoveConfirmHeader`,
    defaultMessage: 'Confirmation',
  },
  bulkRemoveConfirmMessage: {
    id: `${scope}.bulkRemoveConfirmMessage`,
    defaultMessage:
      "Are you sure you want to remove {userFullName}'s report permissions from all {pluralPrimaryOrgCategoryLabel} and {pluralSecondaryOrgCategoryLabel}?",
  },
  confirmButtonText: {
    id: `${scope}.confirmButtonText`,
    defaultMessage: 'Confirm',
  },
  cancelButtonText: {
    id: `${scope}.cancelButtonText`,
    defaultMessage: 'Cancel',
  },
  errorToastTitle: {
    id: `${scope}.errorToastTitle`,
    defaultMessage: 'Error',
  },
  errorToastDefaultMessage: {
    id: `${scope}.errorToastDefaultMessage`,
    defaultMessage: 'Something went wrong. Please try again.',
  },
})
